let pending;

export function loadYouTubePlayerApi() {
  if (window.YT?.Player) return Promise.resolve(window.YT);
  if (pending) return pending;
  pending = new Promise((resolve, reject) => {
    const previous = window.onYouTubeIframeAPIReady;
    let timer;
    const fail = () => {
      clearTimeout(timer);
      pending = null;
      reject(new Error('Trailer player unavailable'));
    };
    window.onYouTubeIframeAPIReady = () => {
      clearTimeout(timer);
      try { previous?.(); } catch { /* another embed must not block this player */ }
      if (window.YT?.Player) resolve(window.YT);
      else fail();
    };
    const script = document.createElement('script');
    script.src = 'https://www.youtube.com/iframe_api';
    script.async = true;
    script.addEventListener('error', fail, { once: true });
    timer = setTimeout(fail, 12000);
    document.head.appendChild(script);
  });
  return pending;
}
